/* eslint-disable @typescript-eslint/naming-convention */
import { BusinessUpdateApiRespProps } from '../repositories/IOnboarding.api';

export class BusinessModel implements IBusinessModelProps {
  businessId: string;
  name: string;
  businessName: string;
  businessEmail: string;
  emailUser: string;
  mobile_phone: string;
  phone: string;
  streetAddress: string;
  fullAddress: string;
  addressExtNumber: string;
  addressIntNumber: string;
  latitude: string | number;
  longitude: string | number;
  zipcode: string;
  countryCode: string;
  countryCallingCode: string;
  languageCode?: string;
  language?: string;
  products: string[];
  hoursOfOperation: OnboardingBusinessConfigScheduleDataProps;
  hoursOfOperationNotes: string;
  facebookUrl: string;
  twitterUrl: string;
  instagramUrl: string;
  tiktokUrl: string;
  paymentMethods: string[];
  businessDescription: string;
  images: {
    // logo?: IndexedImage;
    // about?: IndexedImage;
    // gallery?: IndexedImage[];
    about_image?: IndexedImage;
    contact_image?: IndexedImage;
    feature_image?: IndexedImage;
    gallery?: IndexedImage[];
    logo_image?: IndexedImage;
    spotlight_image?: IndexedImage;
  };
  wizardFinishedAt: string;
  siteUrl: string;
  sites: any[];
  siteAttributes?: any;
  templateId: string | number;
  template_description: string;
  settlement: string;
  locality: string;
  state: string;
  country: string;
  extraSiteUrl: string;
  // CONFIG
  config: {
    gmbStatus: boolean;
    notifications: boolean;
    payments: boolean;
    schedule: boolean;
    services: boolean;
    social: boolean;
    website: boolean;
    registration: boolean;
    hasGmbAccount: boolean;
    gmbCreateOrSync: boolean;
  };

  // IMPORTANT: this field does not belong to the business data, is for internal tracking/use
  isInitialData: boolean;
  suscriptionClient?: any;

  //ECWID DATA
  booking_sync?: boolean;
  ecwic_sync?: boolean;
  ventasclickpay_sync?: boolean;
  allowSite?: boolean;
  allowStore?: boolean;
  allowFoodMenu?: boolean;
  allowCRM?: boolean;
  allowFacebook?: boolean;
  allowBooking?: boolean;
  allowGMB?: boolean;
  allowVentasclickpay?: boolean;
  allowDirectory?: boolean;
  score?: boolean;
  stars?: number;
  review?: string;
  brand?: string;
  brand_id?: number;
  third_id?: string;
  notificationOptions: any;
  color_theme_id?: any;

  constructor(payload: IBusinessModelProps) {
    this.businessId = payload.businessId;
    this.name = payload.name;
    this.businessName = payload.businessName;
    this.businessEmail = payload.businessEmail;
    this.emailUser = payload.emailUser;
    this.mobile_phone = (payload?.mobile_phone || '').replace(/\D/g, '');
    this.phone = (payload?.phone || '').replace(/\D/g, '');
    this.streetAddress = payload.streetAddress;
    this.fullAddress = payload.fullAddress;
    this.addressExtNumber = payload.addressExtNumber;
    this.addressIntNumber = payload.addressIntNumber;
    this.latitude = payload.latitude;
    this.longitude = payload.longitude;
    this.zipcode = payload.zipcode;
    this.countryCode = payload.countryCode;
    this.countryCallingCode = payload.countryCallingCode;
    this.languageCode = payload.languageCode;
    this.language = payload.language;
    this.products = payload.products;
    this.hoursOfOperation = payload.hoursOfOperation;
    this.hoursOfOperationNotes = payload.hoursOfOperationNotes;
    this.facebookUrl = payload.facebookUrl;
    this.twitterUrl = payload.twitterUrl;
    this.instagramUrl = payload.instagramUrl;
    this.tiktokUrl = (payload.tiktok_url !== undefined) ? payload.tiktok_url : '';
    this.paymentMethods = payload.paymentMethods;
    this.businessDescription = payload.businessDescription;
    this.images = payload.images;
    this.wizardFinishedAt = payload.wizardFinishedAt;
    this.siteUrl = payload.siteUrl;
    this.sites = payload.sites;
    this.siteAttributes = null;
    this.templateId = payload.templateId;
    this.template_description = payload.template_description;
    this.settlement = payload.settlement;
    this.locality = payload.locality;
    this.state = payload.state;
    this.country = payload.country;
    this.extraSiteUrl = payload.extraSiteUrl;
    this.config = payload.config;
    this.ecwic_sync = payload.ecwic_sync;
    this.booking_sync = payload.booking_sync;
    this.ventasclickpay_sync = payload.ventasclickpay_sync;
    this.allowStore = payload.allowStore;
    this.allowSite = payload.allowSite;
    this.allowCRM = payload.allowCRM;
    this.allowFacebook = payload.allowFacebook;
    this.allowBooking = payload.allowBooking;
    this.allowGMB = payload.allowGMB;
    this.allowVentasclickpay = payload.allowVentasclickpay;
    this.allowDirectory = payload.allowDirectory;
    this.allowFoodMenu = payload.allowFoodMenu;
    this.score = payload.score;
    this.stars = payload.stars;
    this.review = payload.review;
    this.brand = payload.brand,
    this.brand_id = payload.brand_id;
    this.third_id = payload.third_id;
    this.notificationOptions = {
      email: false,
      push: false,
      sms: false
    }

    this.isInitialData = payload.isInitialData;
    this.suscriptionClient = payload.suscriptionClient;
    this.color_theme_id = payload.color_theme_id;
  }

  static fromApiResponse(payload: BusinessUpdateApiRespProps) {
    const response = new BusinessModel({
      businessId: payload.business_id,
      name: payload.name,
      businessName: payload.business_name,
      businessEmail: payload.business_email,
      emailUser: payload.email_user,
      mobile_phone: payload.mobile_phone,
      phone: payload.phone,
      streetAddress: payload.street_address,
      fullAddress: payload.full_address,
      addressExtNumber: payload.address_ext_number,
      addressIntNumber: payload.address_int_number,
      latitude: payload.latitude,
      longitude: payload.longitude,
      zipcode: payload.zipcode,
      countryCode: payload.country_code,
      countryCallingCode: payload.country_calling_code,
      languageCode: (payload.languageCode) ? payload.languageCode : 'es',
      language: payload.language,
      products: payload.products,
      hoursOfOperation: payload.hours_of_operation,
      hoursOfOperationNotes: payload.hours_of_operation_notes,
      facebookUrl: payload.facebook_url,
      twitterUrl: payload.twitter_url,
      instagramUrl: payload.instagram_url,
      tiktok_url: (payload.tiktok_url !== undefined) ? payload.tiktok_url : '',
      paymentMethods: payload.payment_methods,
      businessDescription: payload.business_description,
      images: {
        logo_image: payload.images.logo_image
          ? new IndexedImage({
              index: 0,
              content: payload.images.logo_image,
              uploaded: true,
            })
          : null,
        about_image: payload.images.about_image
          ? new IndexedImage({
              index: 0,
              content: payload.images.about_image,
              uploaded: true,
            })
          : null,

          contact_image: payload.images.contact_image
          ? new IndexedImage({
              index: 0,
              content: payload.images.contact_image,
              uploaded: true,
            })
          : null,

          feature_image: payload.images.feature_image
          ? new IndexedImage({
              index: 0,
              content: payload.images.feature_image,
              uploaded: true,
            })
          : null,

          spotlight_image: payload.images.spotlight_image
          ? new IndexedImage({
              index: 0,
              content: payload.images.spotlight_image,
              uploaded: true,
            })
          : null,
        gallery: (payload.images.gallery || []).map(
          (data) =>
            new IndexedImage({
              index: data.index,
              content: data.image,
              uploaded: true,
            })
        ),
      },
      wizardFinishedAt: payload.wizard_finished_at,
      siteUrl: payload.site_url,
      siteAttributes: null,
      sites: payload.sites,
      templateId: payload.template_id,
      template_description: payload.template_description,
      settlement: payload.settlement,
      locality: payload.locality,
      state: payload.state,
      country: payload.country,
      extraSiteUrl: payload.extra_site_url,
      config: {
        gmbStatus: payload.BUSINESS_CONFIG_GMB_STATUS,
        notifications: payload.BUSINESS_CONFIG_NOTIFICATIONS,
        payments: payload.BUSINESS_CONFIG_PAYMENTS,
        schedule: payload.BUSINESS_CONFIG_SCHEDULE,
        services: payload.BUSINESS_CONFIG_SERVICES,
        social: payload.BUSINESS_CONFIG_SOCIAL,
        website: payload.BUSINESS_CONFIG_WEBSITE,
        registration: payload.BUSINESS_REGISTRATION,
        hasGmbAccount: payload.USER_HAS_GMB_ACCOUNT,
        gmbCreateOrSync: payload.USER_HAS_GMB_ACCOUNT,
      },
      booking_sync: payload.BOOKING_SYNC,
      ecwic_sync: payload.ecwic_sync,
      brand_id: payload.brand_id,
      ventasclickpay_sync: payload.ventasclickpay_sync,
      allowSite: payload.ALLOW_SITE,
      allowStore: payload.ALLOW_STORE,
      allowFoodMenu: payload.ALLOW_FOOD_MENU,
      allowCRM: payload.ALLOW_CRM,
      allowFacebook: payload.ALLOW_FACEBOOK,
      allowBooking: payload.ALLOW_BOOKING,
      allowGMB: payload.ALLOW_GMB,
      allowVentasclickpay: payload.ALLOW_VENTASCLICKPAY,
      allowDirectory: payload.ALLOW_DIRECTORY,
      score: payload.score,
      stars: payload.stars,
      review: payload.review,
      brand: payload.brand,
      third_id: payload.third_id,
      notificationOptions: {
        email: false,
        push: false,
        sms: false
      },

      // IMPORTANT: this field does not belong to the business data, is for internal tracking/use
      isInitialData: false,
      suscriptionClient: payload.suscriptionClient,
      color_theme_id: payload.color_theme_id
    });
    return response;
  }

  static empty() {
    return new BusinessModel({
      businessId: '',
      name: '',
      businessName: '',
      businessEmail: '',
      emailUser: '',
      mobile_phone: '',
      phone: '',
      streetAddress: '',
      fullAddress: '',
      addressExtNumber: '',
      addressIntNumber: '',
      latitude: '',
      longitude: '',
      zipcode: '',
      countryCode: '',
      countryCallingCode: '',
      languageCode: '',
      language: '',
      products: [],
      hoursOfOperation: [],
      hoursOfOperationNotes: '',
      facebookUrl: '',
      twitterUrl: '',
      instagramUrl: '',
      tiktok_url: '',
      paymentMethods: [],
      businessDescription: '',
      images: {},
      wizardFinishedAt: '',
      siteUrl: '',
      sites: [],
      siteAttributes: null,
      templateId: '',
      template_description: '',
      settlement: '',
      locality: '',
      state: '',
      country: '',
      extraSiteUrl: '',
      config: {
        gmbStatus: null,
        notifications: null,
        payments: null,
        schedule: null,
        services: null,
        social: null,
        website: null,
        registration: null,
        hasGmbAccount: null,
        gmbCreateOrSync: null,
      },

      // IMPORTANT: this field does not belong to the business data, is for internal tracking/use
      isInitialData: true,
      suscriptionClient: null,
      color_theme_id: null
    });
  }
}

export class ModulesConfig implements IModulesConfigProps {
  services: { completed: boolean };
  schedule: { completed: boolean };
  paymentMethods: { completed: boolean };
  socialNetworks: { completed: boolean };
  gmbStatus: { completed: boolean };
  notifications: { completed: boolean };
  website: { completed: boolean };

  constructor(payload: IModulesConfigProps) {
    this.services = payload.services;
    this.schedule = payload.schedule;
    this.paymentMethods = payload.paymentMethods;
    this.socialNetworks = payload.socialNetworks;
    this.gmbStatus = payload.gmbStatus;
    this.notifications = payload.notifications;
    this.website = payload.website;
  }

  static empty() {
    return new ModulesConfig({
      services: { completed: false },
      schedule: { completed: false },
      paymentMethods: { completed: false },
      socialNetworks: { completed: false },
      gmbStatus: { completed: false },
      notifications: { completed: false },
      website: { completed: false },
    });
  }

  toStorage() {
    return {
      services: { completed: this.services.completed },
      schedule: { completed: this.schedule.completed },
      paymentMethods: { completed: this.paymentMethods.completed },
      socialNetworks: { completed: this.socialNetworks.completed },
      gmbStatus: { completed: this.gmbStatus.completed },
      notifications: { completed: this.notifications.completed },
      website: { completed: this.website.completed },
    };
  }
}

export interface IModulesConfigProps {
  services: { completed: boolean };
  schedule: { completed: boolean };
  paymentMethods: { completed: boolean };
  socialNetworks: { completed: boolean };
  gmbStatus: { completed: boolean };
  notifications: { completed: boolean };
  website: { completed: boolean };
}

export interface IBusinessModelProps {
  businessId: string;
  name: string; //the user name

  // BUSINESS CREATION DATA
  businessName: string;
  businessEmail: string;
  emailUser: string;
  mobile_phone: string;
  phone: string;
  streetAddress: string;
  fullAddress: string;
  addressExtNumber: string;
  addressIntNumber: string;
  latitude: string | number;
  longitude: string | number;
  zipcode: string;
  countryCode: string;
  countryCallingCode: string;
  languageCode?: string;
  language?: string;

  // BUSINESS ADDITIONAL INFO
  // - SERVICES
  products: string[];
  // - SCHEDULE
  hoursOfOperation: OnboardingBusinessConfigScheduleDataProps;
  hoursOfOperationNotes: string;
  // - SOCIAL NETWORKS
  facebookUrl: string;
  twitterUrl: string;
  instagramUrl: string;
  tiktok_url?: string;
  // - PAYMENT METHODS
  paymentMethods: string[];

  // WEBSITE DATA
  businessDescription: string;
  images: {
    logo_image?: IndexedImage;
    about_image?: IndexedImage;
    gallery?: IndexedImage[];
    contact_image?: IndexedImage;
    feature_image?: IndexedImage;
    spotlight_image?: IndexedImage;
  };

  // CREATION RESPONSE
  wizardFinishedAt: string;
  siteUrl: string;
  sites?: any[];
  siteAttributes?: any;

  // ADDITIONAL DATA
  templateId: string | number;
  template_description: string;
  settlement: string; //colonia
  locality: string; //Municipio
  state: string; // ciudad/estado
  country: string;
  extraSiteUrl: string;

  // CONFIG
  config: {
    gmbStatus: boolean;
    notifications: boolean;
    payments: boolean;
    schedule: boolean;
    services: boolean;
    social: boolean;
    website: boolean;
    registration: boolean;
    hasGmbAccount: boolean;
    gmbCreateOrSync: boolean;
  };

  // IMPORTANT: this field does not belong to the business data, is for internal tracking/use
  isInitialData: boolean;

  //ECWID DATA
  booking_sync?: boolean;
  ecwic_sync?: boolean;
  ventasclickpay_sync?: boolean;
  allowSite?: boolean;
  allowStore?: boolean;
  allowCRM?: boolean;
  allowFacebook?: boolean;
  allowBooking?: boolean;
  allowGMB?: boolean;
  allowVentasclickpay?: boolean;
  allowDirectory?: boolean;
  allowFoodMenu?: boolean;
  score?: boolean;
  stars?: number;
  review?: string;
  brand?: string;
  brand_id?: number;
  third_id?: string;
  notificationOptions?: any;
  suscriptionClient?: any;
  color_theme_id?: any;
}

export type OnboardingBusinessConfigServicesDataProps = string[];

export type BusinessScheduleType = '24_HOURS' | 'NO_HOURS' | 'HOURS';
export type OnboardingBusinessConfigScheduleDataProps =
  | ['24_HOURS' | 'NO_HOURS']
  | [[[string, string]]]
  | any[]; // example: [[['10:00', '11:00']], [],...]

export type OnboardingBusinessConfigPaymentsDataProps = string[];

export type NetworkNames = 'facebook' | 'twitter' | 'instagram' | 'tiktok';
export type OnboardingBusinessConfigSocialNetworksDataProps = Record<
  NetworkNames,
  string
>;

export interface OnboardingBusinessConfigGmbStatusDataProps {
  status: 'IN_PROGRESS' | 'VALIDATED' | 'DUPLICATED' | 'UNKNOWN';
}

export type OnboardingBusinessConfigNotificationsDataProps = {
  email: boolean;
  sms: boolean;
  push: boolean;
  clients?: boolean;
  generals?: boolean;
  products?: boolean;
  inboxx?: boolean;
  product_innovation?: boolean;
  task?: boolean;
  booking?: boolean;
  store?: boolean;};

export type ConfigNotificationsDataProps = {
  email: boolean;
  sms: boolean;
  push: boolean;
};

export enum OnboardingBusinessConfigPaymentsType {
  efectivo = 'efectivo',
  visa = 'visa',
  mastercard = 'mastercard',
  amex = 'amex',
  check = 'check',
}

export interface OnboardingBusinessConfigWebsiteDataProps {
  type: 'new' | 'existing';
  images: {
    logoImage: IndexedImage;
    bannerImage: IndexedImage;
    productsImage: IndexedImage[];
    mainImage: IndexedImage;
    contactImage: IndexedImage;
    spotlightImage: IndexedImage;
  };
  description: string;
  business_id: number;



  //shortDescription: string;
  /* showSchedule: boolean;
  showServices: boolean;
  showSocialNetworks: boolean; */
}

export class IndexedImage {
  index: number;
  content: string;
  uploaded: boolean;

  constructor(payload: { index: number; content: string; uploaded: boolean }) {
    this.index = payload.index;
    this.content = payload.content;
    this.uploaded = payload.uploaded;
  }
}

export const ONBOARDING_BUSINESS_CONFIG_KEY = 'onboardingBusinessConfig';
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IOnboardingBusinessConfigLocalStorageProps
  extends IBusinessModelProps {}
export interface ModulesConfigLocalStorageProps {
  services: { completed: boolean };
  schedule: { completed: boolean };
  paymentMethods: { completed: boolean };
  socialNetworks: { completed: boolean };
  gmbStatus: { completed: boolean };
  notifications: { completed: boolean };
  website: { completed: boolean };
}
